import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string

if (import.meta.env.DEV && (!supabaseUrl?.trim() || !supabaseAnonKey?.trim())) {
  console.warn(
    '[supabase] Faltan VITE_SUPABASE_URL o VITE_SUPABASE_ANON_KEY. Auth y la base fallarán o apuntarán mal.',
  )
}

/**
 * En desarrollo, las Edge Functions se solicitan vía mismo origen (Vite proxy → Supabase)
 * para evitar fallos de CORS en el preflight OPTIONS hacia *.supabase.co.
 */
function devFunctionsProxyFetch(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  if (!import.meta.env.DEV || !supabaseUrl) {
    return fetch(input, init)
  }

  if (input instanceof Request) {
    if (!input.url.includes('/functions/v1/')) {
      return fetch(input, init)
    }
    const u = new URL(input.url)
    const local = `${window.location.origin}${u.pathname}${u.search}`
    return fetch(new Request(local, input))
  }

  const urlStr = typeof input === 'string' ? input : input.href
  if (!urlStr.includes('/functions/v1/')) {
    return fetch(input, init)
  }
  const u = new URL(urlStr)
  const local = `${window.location.origin}${u.pathname}${u.search}`
  return fetch(local, init)
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  global: { fetch: devFunctionsProxyFetch },
})
